module.exports = __webpack_public_path__ + "155abc7dec917203e8d688738e6572b6.jpg";